
    import { Options, Vue } from 'vue-class-component';
    import {ref } from 'vue';
    import Common from '@/services/common.js';
    import moment from 'moment';  
    import { useToast } from "vue-toastification";
    import Axios from "axios";     
    import { Form, Field,ErrorMessage ,useForm} from 'vee-validate';
    import $ from 'jquery'; 

    @Options({ 
        components: { 
            Form,
            Field,
            useForm,
            ErrorMessage
        },
        props: {
            countries       :   [Number, String],
            current_step    :   Number,  
            load_on         :   Number,  
        },  
    })
    
    export default class Beneficiary extends Vue {  
        current_step;  
        show_Tdirectors:any=0;
        show_form=0;
        show_dir_form = 0;
        countries; 
        load_on;
        active_beneficiary_id :any =0;
        active_director_id :any =0;
        form = {}; 
        beneficiaries       :any        =   [];
        
        toast:any                   = useToast();
        local_storage   :any;
        closeImage = 'caprock/images/close.svg';  
        data () {     
           
            return {      
                countries               :   this.countries,  
                active_beneficiary_id   :   this.active_beneficiary_id,
                active_director_id      :   this.active_director_id,
                show_form               :   this.show_form,
                show_dir_form           :   this.show_dir_form,  
                current_step            :   this.current_step,  
                load_on                 :   this.load_on,  
                beneficiaries                :   this.beneficiaries, 
                closeImage              :   this.closeImage, 
                show_Tdirectors         :   this.show_Tdirectors,
            } 
        }    
        created() {    
            this.local_storage=JSON.parse((localStorage.getItem('caprock-local') || "{}"));     
            return true;
        }
        mounted() { 
            this.beneficiary_list();  
        }  
 
        
        validateEmail(value) { 
            const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
            if (typeof value!='undefined' && !regex.test(value)) { 
                return 'This field must be a valid email'; 
            } 
            return true;
        }  
        requiredField(value) { 
            if (!value) {
                return 'This field is required';
            } 
            return true;
        }
        selectField(value) { 
            if (!value || value=='') {
                return 'Please select one of option';
            } 
            return true;
        } 
        mobileField(value){ 
            if(typeof value!='undefined'){
                var phoneNum = value.replace(/[^\d]/g, '');
                if(phoneNum.length <7 || phoneNum.length > 12) {  
                    return 'This field must be a valid mobile number';
                }  
                return true;
            }
            return true; 
        } 
        async beneficiary_list(){
            await Common.get_beneficiaries(this.local_storage['access-token'])
                .then(response => { 
                    if (typeof response.data !== 'undefined' && response.data.success == 200) {  
                        var beneficiaries   =   response.data.beneficiaries;
                        for (var i = beneficiaries.length - 1; i >= 0; i--) {
                            if(beneficiaries[i].beneficiary_type==1){
                                beneficiaries[i].beneficiary_type='Indvidual';
                            }
                            if(beneficiaries[i].beneficiary_type==2){
                                beneficiaries[i].beneficiary_type='Corporate';
                            } 
                            // beneficiaries[i].directors=[];
                        } 
                        this.beneficiaries  =   beneficiaries;    
                    }
                }).catch(e => {
                  console.log(e)
            });
        }
        

        async director_list(beneficiary_id){
            // await Common.get_beneficiary_directors(this.local_storage['access-token'],beneficiary_id)
            // .then(response => { 
            //     if (typeof response.data !== 'undefined' && response.data.success == 200) {  
            //         var beneficiaries   =   this.beneficiaries;
            //         for (var i = beneficiaries.length - 1; i >= 0; i--) {
            //             if (beneficiaries[i].beneficiary_id==beneficiary_id) {
            //                 beneficiaries[i].directors=response.data.directors;
            //             }
            //         } 
            //         this.beneficiaries  =   beneficiaries;     
            //     }
            // }).catch(e => {
            //     console.log(e)
            // });
        }

        add_director(beneficiary_id){
            alert('ADD_'+beneficiary_id);
        } 
        async show_directors(beneficiary_id){
            this.active_beneficiary_id=beneficiary_id   
            await this.director_list(beneficiary_id);
            this.show_Tdirectors =beneficiary_id;   
        }
        htmlToElements(html) {
            var template = document.createElement('template');
            html = html.trim(); // Never return a text node of whitespace as the result
            template.innerHTML = html;
            return template.content.firstChild;
        }
        getImgUrl(path) { 
            return require('@/assets/' + path);
        }
 

        hide_directors(dir_id){ 
            this.show_Tdirectors =0;  
        }

 

        save_beneficiary(){    
            setTimeout(() => this.load_on=1, 100); 
            var form_records  = JSON.parse(JSON.stringify((this.form)));   
            let form_data = new FormData();  
            form_data.append('user_token'           ,this.local_storage['access-token']);              
            

            var sT11 = [
                'beneficiary_type',
                'company_type',
                'beneficiary_name',
                'beneficiary_email',
                'beneficiary_phone_no' 
             ]; 
            for (var sT = 0; sT < sT11.length; sT++) {   
                if(typeof form_records[sT11[sT]]!=='undefined' && form_records[sT11[sT]]!='undefined'){
                    form_data.append(sT11[sT],form_records[sT11[sT]]);    
                }else{
                    form_data.append(sT11[sT],'');    
                } 
            }   
              
            Axios.defaults.headers.common['Access-Control-Allow-Origin'] =  '*';
            var url     =   Common.base_url()+'save-onboard-trust-beneficiary';   
            Axios.post(
                url, 
                form_data, 
                {
                    headers: {  
                        'Content-Type': 'multipart/form-data'
                    } 
                }
            )
            .then(response => { 
                this.beneficiary_list();   
                // this.$emit('recipientFetch');
                if(response.data.success==200){
                    this.$nextTick(() => { 
                        var tBox :any= this.$refs.beneficiary_form;
                        tBox.resetForm(); 
                    });  
                    setTimeout(() => this.show_form =0, 800);   
                    setTimeout(() => this.load_on=0, 500);  
                    this.toast.success(response.data.message);   
                }else{ 
                    setTimeout(() => this.load_on=0, 500);  
                    this.toast.error(response.data.message);   
                } 
            })
            .catch(error => {
                setTimeout(() => this.load_on=0, 500);   
            });   
        } 

        ask_delete(beneficiary_id){
            this.active_beneficiary_id = beneficiary_id;
            this.openModal('delete_beneficiary');
        }
        delete_beneficiary(beneficiary_id){ 
            setTimeout(() => this.load_on=1, 100); 
            var form_records  = JSON.parse(JSON.stringify((this.form)));   
            let form_data = new FormData();  
            form_data.append('user_token'           ,this.local_storage['access-token']);              
            form_data.append('beneficiary_id'          ,beneficiary_id); 
              
            Axios.defaults.headers.common['Access-Control-Allow-Origin'] =  '*';
            var url     =   Common.base_url()+'delete-onboard-trust-beneficiary';   
            Axios.post(
                url, 
                form_data, 
                {
                    headers: {  
                        'Content-Type': 'multipart/form-data'
                    } 
                }
            )
            .then(response => { 
                this.active_beneficiary_id=0 ;
                this.closeModal('delete_beneficiary');
                this.beneficiary_list();  

                // this.$emit('recipientFetch');
                if(response.data.success==200){  
                    this.$nextTick(() => { 
                        var tBox :any= this.$refs.beneficiary_form;
                        tBox.resetForm(); 
                    }); 
                    setTimeout(() => this.load_on=0, 500);  
                    this.toast.success(response.data.message); 
                }else{ 
                    setTimeout(() => this.load_on=0, 500);  
                    this.toast.error(response.data.message);   
                } 
            })
            .catch(error => {
                setTimeout(() => this.load_on=0, 500);   
            });   
        } 



        save_director(){       
            setTimeout(() => this.load_on=1, 100); 
            var form_records  = JSON.parse(JSON.stringify((this.form)));   
            let form_data = new FormData();  
            form_data.append('user_token'           ,this.local_storage['access-token']);              
             
            form_data.append('beneficiary_id'           ,this.active_beneficiary_id);
            form_data.append('director_name'        ,form_records['director_name']);
            form_data.append('director_email'       ,form_records['director_email']);
            form_data.append('director_phone_no'    ,form_records['director_phone_no']);
              
            Axios.defaults.headers.common['Access-Control-Allow-Origin'] =  '*';
            var url     =   Common.base_url()+'save-onboard-beneficiary-director';   
            Axios.post(
                url, 
                form_data, 
                {
                    headers: {  
                        'Content-Type': 'multipart/form-data'
                    } 
                }
            )
            .then(response => { 
                this.director_list(this.active_beneficiary_id);   
                this.$emit('recipientFetch');
                // this.$emit('directorFetch');
                if(response.data.success==200){
                    this.form['director_name']=null;
                    this.form['director_email']=null;
                    this.form['director_phone_no']=null; 

                    setTimeout(() => this.show_dir_form =0, 800);   
                    setTimeout(() => this.load_on=0, 500);  
                    this.toast.success(response.data.message);   
                }else{ 
                    setTimeout(() => this.load_on=0, 500);  
                    this.toast.error(response.data.message);   
                } 
            })
            .catch(error => {
                setTimeout(() => this.load_on=0, 500);   
            });   
        }  
        ask_director_delete(director_id,beneficiary_id){
            this.active_director_id = director_id;
            this.active_beneficiary_id = beneficiary_id;
            this.openModal('delete_director');
        }
        delete_director(director_id,beneficiary_id){ 
            setTimeout(() => this.load_on=1, 100); 
            var form_records  = JSON.parse(JSON.stringify((this.form)));   
            let form_data = new FormData();  
            form_data.append('user_token'           ,this.local_storage['access-token']);              
            form_data.append('director_id'          ,director_id);            
            form_data.append('beneficiary_id'          ,beneficiary_id); 
              
            Axios.defaults.headers.common['Access-Control-Allow-Origin'] =  '*';
            var url     =   Common.base_url()+'delete-onboard-beneficiary-director';   
            Axios.post(
                url, 
                form_data, 
                {
                    headers: {  
                        'Content-Type': 'multipart/form-data'
                    } 
                }
            )
            .then(response => { 
                this.director_list(beneficiary_id);   
                this.$emit('recipientFetch');
                this.active_beneficiary_id = 0 ;
                this.closeModal('delete_director'); 
                // this.$emit('directorFetch'); 
                if(response.data.success==200){   
                    setTimeout(() => this.load_on=0, 500);  
                    this.toast.success(response.data.message); 
                }else{ 
                    setTimeout(() => this.load_on=0, 500);  
                    this.toast.error(response.data.message);   
                } 
            })
            .catch(error => {
                setTimeout(() => this.load_on=0, 500);   
            });   
        } 
 

        openModal(id: any) {
            $('#' + id).addClass('d-block');
            $('#' + id).addClass('show');
            $('#' + id).css('overflow-y', 'scroll');
        }
        closeModal(id: any,reload=false) {
            $('#' + id).removeClass('d-block');
            $('#' + id).addClass('d-none');
            $('#' + id).removeClass('show');
            if(reload==true){
                location.reload();
            }
        }  

        

    }
